// Mock data for Global Gateway website

export const companyInfo = {
  name: "Global Gateway",
  tagline: "From Farmers and Rural Artisans to the World.",
  location: "Bengaluru, India",
  email: "contact@theglobalGateway.in",
  whatsapp: "8073470770",
  address: "Kengeri, Bengaluru, Karnataka 560069, India",
  mission: "To empower farming and artisan communities through fair trade and ethical global export practices.",
  vision: "A world where sustainable products and rural craftsmanship reach every market.",
  about: "Global Gateway is a start-up exporter from Bengaluru, India, connecting farmers and rural artisans across southern India with global buyers. We specialize in premium-quality organic spices, coffee, tea, and eco-friendly handmade products like jute bags, bamboo baskets, and woven crafts."
};

export const coreValues = [
  {
    title: "Integrity",
    description: "We maintain the highest standards of honesty and transparency in all our dealings."
  },
  {
    title: "Sustainability",
    description: "Environmental responsibility guides every decision we make, from sourcing to shipping."
  },
  {
    title: "Quality",
    description: "Premium organic products that meet international standards and exceed expectations."
  },
  {
    title: "Fair Trade",
    description: "Ensuring farmers and artisans receive fair compensation for their exceptional work."
  }
];

export const productCategories = [
  {
    id: 1,
    name: "Organic Spices",
    description: "Premium quality organic spices sourced directly from southern Indian farms.",
    image: "https://images.unsplash.com/photo-1663325265966-0d17de3e85c5?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&?w=800&h=600&fit=crop&q=80"
  },
  {
    id: 2,
    name: "Coffee & Tea",
    description: "Estate-grown, single-origin organic coffee and tea varieties.",
    image: "https://images.unsplash.com/photo-1447933601403-0c6688de566e?w=800&h=600&fit=crop&q=80"
  },
  {
    id: 3,
    name: "Jute & Handmade Products",
    description: "Eco-friendly handcrafted items including jute bags, bamboo baskets, and woven crafts.",
    image: "https://images.unsplash.com/photo-1758487424832-a53ae6cdefdb?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format?w=800&h=600&fit=crop&q=80"
  }
];

export const spiceProducts = [
  { id: 1, name: "Bay Leaf", description: "Aromatic organic bay leaves for culinary excellence", image: "https://images.unsplash.com/photo-1592380222497-0c40d4936b42?w=400&h=400&fit=crop&q=80" },
  { id: 2, name: "Cardamom", description: "Premium green cardamom with intense aroma", image: "https://images.unsplash.com/photo-1701166627787-12d9fdd437cc?w=400&h=400&fit=crop&q=80" },
  { id: 3, name: "Cassia", description: "High-quality cassia bark for global markets", image: "https://images.unsplash.com/photo-1601379760561-dabddc5ff4cd?w=400&h=400&fit=crop&q=80" },
  { id: 4, name: "Cinnamon", description: "Organic Ceylon cinnamon sticks", image: "https://images.unsplash.com/photo-1553499944-e4297a0af1bd?w=400&h=400&fit=crop&q=80" },
  { id: 5, name: "Clove", description: "Premium whole cloves with rich flavor", image: "https://plus.unsplash.com/premium_photo-1722945788534-7dc8af951829?w=400&h=400&fit=crop&q=80" },
  { id: 6, name: "Coriander", description: "Organic coriander seeds and powder", image: "https://plus.unsplash.com/premium_photo-1725997402871-4aea35710632?w=400&h=400&fit=crop&q=80" },
  { id: 7, name: "Kokam", description: "Traditional kokam for authentic Indian flavors", image: "https://plus.unsplash.com/premium_photo-1726877060096-882c2ac6d13c?w=400&h=400&fit=crop&q=80" },
  { id: 8, name: "Mustard", description: "Premium mustard seeds for global cuisine", image: "https://plus.unsplash.com/premium_photo-1725551070695-303d5790b287?w=400&h=400&fit=crop&q=80" }
];

export const coffeeTeaProducts = [
  { id: 1, name: "Arabica Coffee", description: "Single-origin organic Arabica from Karnataka estates", image: "https://images.unsplash.com/photo-1447933601403-0c6688de566e?w=400&h=400&fit=crop&q=80" },
  { id: 2, name: "Robusta Coffee", description: "Bold organic Robusta beans", image: "https://images.unsplash.com/photo-1710082336769-618ecffe6e7f?w=400&h=400&fit=crop&q=80" },
  { id: 3, name: "Green Tea", description: "Premium organic green tea leaves", image: "https://images.unsplash.com/photo-1627435601361-ec25f5b1d0e5?w=400&h=400&fit=crop&q=80" },
  { id: 4, name: "Black Tea", description: "Estate-grown organic black tea", image: "https://images.unsplash.com/photo-1576092768241-dec231879fc3?w=400&h=400&fit=crop&q=80" }
];

export const handmadeProducts = [
  { id: 1, name: "Jute Bags", description: "Eco-friendly handwoven jute bags", image: "https://images.unsplash.com/photo-1615485737442-7d6ab9f64db9?w=400&h=400&fit=crop&q=80" },
  { id: 2, name: "Bamboo Baskets", description: "Handcrafted bamboo storage baskets", image: "https://images.unsplash.com/photo-1635719918971-bf907c2b1281?w=400&h=400&fit=crop&q=80" },
  { id: 3, name: "Woven Crafts", description: "Traditional handwoven decorative items", image: "https://plus.unsplash.com/premium_photo-1691030657797-02ed37204bb5?w=400&h=400&fit=crop&q=80" },
  { id: 4, name: "Eco Bags", description: "Sustainable shopping bags", image: "https://images.unsplash.com/photo-1615290144628-8fa0f0d61658?w=400&h=400&fit=crop&q=80" }
];

export const testimonials = [
  {
    id: 1,
    name: "Michael Anderson",
    company: "European Spice Traders Ltd.",
    country: "Netherlands",
    text: "Global Gateway has become our trusted partner for organic spices. Their quality control and ethical sourcing practices are exceptional.",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Williams",
    company: "Fair Trade Foods Inc.",
    country: "USA",
    text: "The coffee quality is outstanding. We appreciate their commitment to farmer empowerment and sustainable practices.",
    rating: 5
  },
  {
    id: 3,
    name: "Yuki Tanaka",
    company: "Tokyo Organic Imports",
    country: "Japan",
    text: "Excellent service and premium products. The handmade items are particularly popular with our customers.",
    rating: 5
  }
];

export const impactMetrics = [
  { label: "Farmers Supported", value: "200+" },
  { label: "Artisans Empowered", value: "50+" },
  { label: "Export Countries", value: "15+" },
  { label: "Organic Certified Products", value: "100%" }
];

export const certifications = [
  "APEDA Registered",
  "Organic Certification (India Organic)",
  "Fair Trade Practices",
  "FSSAI Licensed"
];

export const exportDestinations = [
  "United States", "United Kingdom", "Germany", "Netherlands", "France",
  "Japan", "Australia", "Canada", "Singapore", "UAE",
  "Italy", "Spain", "Belgium", "Switzerland", "Sweden"
];

export const socialLinks = [
  // { platform: "LinkedIn", url: "https://linkedin.com/globalgateway_india" },
  { platform: "Instagram", url: "https://instagram.com/globalgateway_india" },
  { platform: "Facebook", url: "https://facebook.com/globalgateway_india" }
];